// libs
import React, { memo } from 'react';
import { css as _css } from '@emotion/core';
import { styled } from '@nykaa/ui-components';

import { BASE_GUTTER_SPACE, BREAKPOINTS, COLORS } from 'shared/styles/base';

// styles
const line = _css`
    background: ${COLORS.PLACEHOLDER};
    height: 11px;
    margin: ${BASE_GUTTER_SPACE}px;
`;

const Container = styled.div<{ showSizes: boolean }>`
  .p-img {
    width: 100%;
    padding-top: 133.334%;
    background: ${({ theme }) => theme.colors.shimmerBg};
  }

  .p-title {
    background: ${({ theme }) => theme.colors.shimmerBg};
    height: ${({ theme }) => theme.spacing.spacing60};
    margin: ${({ theme }) =>
      `${theme.spacing.spacing40} ${theme.spacing.spacing40} ${theme.spacing.spacing10}`};
    width: 30%;
  }

  .p-subTitle {
    background: ${({ theme }) => theme.colors.shimmerBg};
    height: ${({ theme }) => theme.spacing.spacing80};
    margin: ${({ theme }) =>
      `${theme.spacing.spacing40} ${theme.spacing.spacing40} ${theme.spacing.spacing10}`};
    width: 80%;
  }

  .p-line3 {
    ${line}
    background: ${({ theme }) => theme.colors.shimmerBg};
    height: ${({ theme }) => theme.spacing.spacing60};
    margin: ${({ theme }) => `${theme.spacing.spacing20} ${theme.spacing.spacing40} 0`};
    width: 25%;

    ${({ showSizes }) => showSizes === false && `margin-bottom: 9px;`}
  }

  .p-line4 {
    ${line}
    height: ${({ theme }) => theme.spacing.spacing100};
    background: ${({ theme }) => theme.colors.shimmerBg};
    margin-bottom: ${({ theme }) => theme.spacing.spacing20};
    width: 55%;
  }

  .p-color-options {
    height: 20px;
  }
  .p-line-bp {
    background: ${({ theme }) => theme.colors.shimmerBg};
    margin: ${({ theme }) => `${theme.spacing.spacing20} ${theme.spacing.spacing40} 0`};
    height: 16px;
    width: 60%;
  }

  @media (min-width: ${BREAKPOINTS.TABLET_BIG + 1}px) {
    .p-title {
      height: 14px;
      margin: 12px 8px 4px;
    }

    .p-subTitle {
      height: 18px;
      margin: 12px 8px 4px;
    }

    .p-line3 {
      height: 14px;
      margin: 6px 8px 0;
    }

    .p-line4 {
      height: 22px;
      margin: 0 8px 4px;
    }
  }
`;

interface IPlaceholderProps {
  className?: string;
  showSizes?: boolean;
  showPriceReveal?: boolean;
  showColorOptions?: boolean;
  isBestPriceEnabled?: boolean;
}

function Placeholder({
  className = '',
  showSizes = true,
  showPriceReveal = false,
  showColorOptions = false,
  isBestPriceEnabled,
}: IPlaceholderProps) {
  return (
    <Container className={className} showSizes={showSizes}>
      <div className="p-img" />
      <div className="p-title" />
      <div className="p-subTitle" />
      <div className="p-line3" />

      {isBestPriceEnabled && <div className="p-line-bp" />}
      {showPriceReveal && (
        <>
          <div className="p-title" />
          <div className="p-line3" />
        </>
      )}
      {showSizes && <div className="p-line4" />}
      {showColorOptions && <div className="p-color-options"></div>}
    </Container>
  );
}

export default memo(Placeholder);
